import { lazy } from 'react'

const QRCodeLazy = lazy(() =>
  import(/* webpackChunkName: "QRCode" */ './qrcode'),
)

export default QRCodeLazy
